import React from 'react';
import { useLocation } from 'react-router-dom';
import { canonicalHomeSmartPath, isHomeSmartSite } from '../../utils/brandSession';
export const SiteRedirect = ({ to }) => {
  const destination = React.useRef(null);
  React.useEffect(() => {
    if (destination.current === to) return;
    destination.current = to;
    window.location.replace(to);
  }, [to]);
  return null;
};
export const SiteBoundary = ({ children }) => {
  const location = useLocation();
  const homeSmart = isHomeSmartSite();
  const target = canonicalHomeSmartPath();
  React.useEffect(() => {
    document.title = homeSmart ? 'Home Smart' : 'HWsmart';
    const icon = document.querySelector('link[rel="icon"]');
    if (icon) icon.href = homeSmart ? '/home-smart-logo.png' : '/1.png';
    const description = document.querySelector('meta[name="description"]');
    if (description) description.content = homeSmart ? 'Home Smart — gestione delle tue strutture, ospiti e prenotazioni.' : 'HWsmart - Gestione Prenotazioni e Analytics';
  }, [homeSmart, location.pathname]);
  return target ? <SiteRedirect to={target} /> : children;
};
export const InternalSiteOnly = ({ children }) => {
  useLocation();
  return isHomeSmartSite() ? null : children;
};